<template>
    <!-- Элемент компонента, который будет отображать список с помощью VuePerfectScrollbar -->
    <component
        id="sectionComponent"
        :is="'VuePerfectScrollbar'"
        class="infinite_scroll_wrapper"
        ref="listScroll"
        :settings="scrollSettings"
        :key="$vs.rtl"
        @ps-y-reach-end="infiniteHandle">  <!-- Добавляет обработчик события, когда скролл достигает конца -->
        <ul style="margin-bottom: 120px;" v-if="list.length">
            <!-- Отображает каждый элемент списка в виде li элемента -->
            <li class="todo_todo-item cursor-pointer"
                v-for="(item, index) in list"
                :key="`d_${index}`"
                :id="`list_item_id_${index}`"
                @click="on_item_click(item, index)">
                <!-- Компонент, который будет использоваться для отображения каждого элемента списка -->
                <component
                    class="emc_card px-4 py-4 list-item-component"
                    :is="list_item_component"
                    :item="item"
                    :index="index"/>
            </li>
        </ul>
        <div class="mt-4 ml-5 mr-5" v-if="list.length === 0">
            <vs-alert active="true">
                {{ $t("no_data_text") }}
            </vs-alert>
        </div>
        <div id="infinite_loader" class="vs-con-loading__container"></div>
    </component>
</template>

<script>
// Импортирует два миксина: PaginationMixin и VuePerfectScrollbar
import PaginationMixin from "@/pages/Home/ListGlobalComponents/Mixin/PaginationMixin";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    // Устанавливает имя компонента
    name: "ListItem",
    // Включает два миксина в компонент
    mixins:[
        PaginationMixin,

    ],
    components:{
        VuePerfectScrollbar,
    },
    mounted() {
        let sectionComponent = document.getElementById('sectionComponent')
        sectionComponent.addEventListener('scroll', this.onScroll);
    },
    // Определяет данные компонента
    data() {
        return {
            // Устанавливает настройки для VuePerfectScrollbar
            scrollSettings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
        }
    },
    // Определяет свойства компонента
    props:{
        // Список элементов
        list:Array,
        // Компонент, который будет использоваться для отображения каждого элемента списка
        list_item_component:Object,
    },
    // Определяет методы компонента
    methods:{
        onScroll(val1,val2){
            this.$emit('onScroll')
        },
        // Обрабатывает клик по элементу списка
        on_item_click(item, list_item_id_index){
            // Вызывает событие, чтобы родительский компонент мог обработать клик
            this.$emit('on_item_click', { item, list_item_id_index })
        },
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions{
    .con-vs-tabs{
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs{
        display: none;
    }
}
.emc_list_tabs{
    .con-ul-tabs{
        display: none;
    }
    .vs-tabs--content{
        padding: 0px;
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher{
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher){
        height: 100%;
    }
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.full-vs-sidebar{
    .mail-sidebar-content{
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header{
        box-shadow: 0 4px 6px rgba(0,0,0,.04);
        border-bottom: 1px solid #eee;
    }
}
</style>
